"use client";

import JobDetailContent, { type JobData } from "@/components/Company/JobDetailContent";

const jobData: JobData = {
  title: "Mobile Application Pentest",
  sections: [
    {
      title: "Key Responsibilities",
      items: [
        "Conduct thorough security assessments of mobile applications, covering both Android and iOS platforms.",
        "Create proof-of-concept exploits for identified vulnerabilities.",
        "Document findings comprehensively for both technical and non-technical audiences.",
        "Develop scripts and tools to automate the penetration testing process.",
        "Collaborate effectively within the team to enhance workflow and processes.",
        "Stay updated with the latest mobile security threats and exploit techniques.",
        "Develop, refine, and implement in-house methodologies for mobile app security testing.",
        "Actively participate in mobile app exploit research to continuously improve skills and knowledge.",
        "Join and collaborate with the team in participating in various cybersecurity competitions, enhancing both individual and team skills in real-world scenarios.",
      ],
    },
    {
      title: "Required Experience and Skills",
      items: [
        "Minimum of 2 years of experience in cybersecurity with a focus on mobile security.",
        "Strong understanding of mobile application fundamentals and security principles.",
        "Proficient in reverse engineering and mobile application analysis.",
        "In-depth knowledge of Android and iOS operating system internals.",
        "Familiarity with mobile application vulnerabilities and web API penetration techniques.",
        "Proven ability to bypass security protections in mobile applications.",
        "Proficient in at least one of the following programming/scripting languages: Python, C#, C, Golang, Assembly, PHP, and Bash. Other programming language can be considered.",
        "Experience in CTFs, hacking competitions, or bug bounty programs is highly desirable.",
      ],
    },
    {
      title: "Benefits",
      items: [
        "Opportunity to engage in off-topic research, exploring various security domains.",
        "Work alongside a team of experienced professionals in diverse security fields.",
        "Active participation in security competitions, fostering team building and skill enhancement.",
        "Access to continuous learning and career development opportunities.",
      ],
    },
    {
      title: "Soft Skills",
      items: [
        "Good command in both Written and Spoken English.",
        "An ability to work under a dynamic environment and remotely.",
        "Good team player.",
        "Able to work under pressure with positive attitude towards the team.",
        "Reliable responsibility.",
        "Must be able to travel abroad.",
      ],
    },
  ],
  closingNote:
    "ECQ firmly believes in Skills and Quality of Work. No certification or degree is required. All candidates are welcomed and will be screened through technical interview. All applications will be treated as strictly confidential. Successful candidate will receive attractive remuneration package. Interested applicants please submit your application and resume with a recent photo either by post or e-mail to the following address.",
  applyEmail: "hr@e-cq.net",
};

export default function MobileApplicationPentestJD() {
  return <JobDetailContent data={jobData} />;
}
